// extracted by mini-css-extract-plugin
module.exports = {"no-application-data-flow-error":"noApplicationDataFlow_no-application-data-flow-error__1_Fbz"};